"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = _interopRequireDefault(require("../../../icon/Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var MultiValueRemove = function MultiValueRemove(_ref) {
  var data = _ref.data,
    _onClick = _ref.innerProps.onClick;
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    className: "selected-item-icon",
    icon: "ion-android-delete",
    size: 14,
    "aria-label": "Remove item",
    onClick: function onClick() {
      return _onClick(data.value);
    }
  });
};
MultiValueRemove.propTypes = {
  data: _propTypes["default"].shape({}).isRequired,
  innerProps: _propTypes["default"].shape({}).isRequired
};
MultiValueRemove.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "MultiValueRemove",
  "props": {
    "data": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": true
    },
    "innerProps": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": true
    }
  }
};
var _default = MultiValueRemove;
exports["default"] = _default;